import { BulleAide, FieldRadioGroup, Question } from '@workspace/core-ts/components';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { Incendie, Indemnisation, Info, Protection, Trophee } from '@workspace/core-ts/icons-amo';
import { booleanOptions } from '@workspace/utils';
import type { FormSchemaType } from '../schema';

export default function Garanties() {
    const methods = useSmartFormGlobal<FormSchemaType>();

    return (
        <SmartFormGlobal {...methods} className="mx-auto">
            <Question buttonLabel="Allons-y !" className="text-center">
                <Trophee />
                <Question.Title>
                    <b>Tenez bon</b>, nous avons presque terminé !
                </Question.Title>
                <Question.Description>
                    <p>
                        Dans quelques instants, nous allons pouvoir établir <em>votre devis sur mesure</em> 😃
                    </p>
                    <p>
                        Avant ça, nous avons encore <b>quelques questions</b> à vous poser, pour <b>identifier vos besoins</b>.
                    </p>
                </Question.Description>
            </Question>

            <Question>
                <Question.Header>
                    <Incendie />
                    <Question.SubTitle>Souhaitez-vous assurer votre véhicule ...</Question.SubTitle>
                    <Question.Title>
                        En cas <b>de vol</b> ou <b>d'incendie</b> ?
                    </Question.Title>
                </Question.Header>
                <FieldRadioGroup name="DemandeTarif.DevoirConseil.DevoirVol" options={booleanOptions} />
            </Question>

            <Question>
                <Question.Header>
                    <Protection />
                    <Question.SubTitle>Souhaitez-vous assurer votre véhicule ...</Question.SubTitle>
                    <Question.Title>
                        En cas de <b>dommage tous accidents</b> (tous risques) ?
                    </Question.Title>
                </Question.Header>
                <FieldRadioGroup name="DemandeTarif.DevoirConseil.DevoirDommage" options={booleanOptions} />
            </Question>

            <Question>
                <Question.Header>
                    <Indemnisation />
                    <Question.SubTitle>Souhaitez-vous être indémnisé ...</Question.SubTitle>
                    <Question.Title>
                        En cas d'<b>accident responsable</b> qui pourrait engendrer de <b>graves blessures</b> voire même un <b>décès</b> ?
                    </Question.Title>
                </Question.Header>
                <BulleAide
                    icon={<Info />}
                    description="Mais si vous êtes le responsable ou que vous avez provoqué seul cet accident, les impacts financiers d'une invalidité ou même d'un décès peuvent être importants pour vous et vos proches. Vous pouvez vous assurer pour faire face à ces conséquences financières."
                    title="Si vous êtes victime et blessé(e) suite à un accident causé par un autre véhicule, vos blessures seront indemnisées par son assureur."
                />
                <FieldRadioGroup name="DemandeTarif.DevoirConseil.DevoirPCC" options={booleanOptions} />
            </Question>
        </SmartFormGlobal>
    );
}
